"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _util = _interopRequireDefault(require("@/assets/static/js/utils/util.js"));
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _api = require("../../api/api");
var _default = exports.default = {
  name: 'merchant_form',
  props: {
    plateCode: String,
    sortConfig: Object
  },
  data: function data() {
    return {
      cityData: _appCitysData.default.cityDataWithoutDistrict,
      //地址库
      province: '',
      city: '',
      classifyData: [],
      //危化商铺分类数据
      plateId: '',
      //危化商铺板块Id
      classifyId: '',
      //危化商铺分类Id
      form: {
        category: '',
        cityValue: [],
        contactName: '',
        contactPhone: '',
        title: '',
        content: ''
      },
      rules: {
        category: [{
          required: true,
          message: '请选择分类',
          trigger: 'blur'
        }],
        cityValue: [{
          required: true,
          message: '请选择所在城市',
          trigger: 'change'
        }],
        contactName: [{
          required: true,
          message: '请输入联系人姓名',
          trigger: 'blur'
        }],
        contactPhone: [{
          required: true,
          message: '请输入联系人电话',
          trigger: 'blur'
        }, {
          min: 11,
          max: 11,
          message: '手机号长度有误',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入标题名称',
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: '请输入内容描述',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    // 获取危化商铺板块分类ID
    this.getClassifyData();
  },
  methods: {
    /*type=“number”在safari、firefox浏览器无效
    采用oninput="value=value.replace(/^\.+|[^\d.]/g,'')"限制输入内容
    但是当输入法为中文时，v-model的数据无法和输入值双向绑定，需要使用此方法重新赋值*/
    phoneChange: function phoneChange(e) {
      this.form.contactPhone = e.target.value;
    },
    //点击表单标题栏
    clickFormTitle: function clickFormTitle(classifyId, classifyName) {
      this.classifyId = classifyId;
      this.form.category = classifyName;
    },
    //提交表单
    clickToSubmitForm: function clickToSubmitForm(formName) {
      var _this = this;
      console.log("formName:", formName);
      console.log("phone:" + this.form.contactPhone);
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.saveFormData();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //选择城市
    selectCity: function selectCity(value) {
      if (value.length > 0) {
        this.province = value[0];
      }
      if (value.length > 1) {
        this.city = value[1];
      }
      this.form.cityValue = value;
      console.log("value:", value);
      console.log("cityValue:", this.form.cityValue);
    },
    //获取危化商铺板块分类数据
    getClassifyData: function () {
      var _getClassifyData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var jsonParam, _yield$apiGetPlateCla, data, plateData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              jsonParam = {
                jsonParamete: JSON.stringify({
                  fun: "getplateclassifybycode",
                  param: {
                    plateCode: this.plateCode,
                    classifyCode: ""
                  },
                  version: 1
                })
              };
              _context.next = 3;
              return (0, _api.apiGetPlateClassifyData)(jsonParam);
            case 3:
              _yield$apiGetPlateCla = _context.sent;
              data = _yield$apiGetPlateCla.data;
              console.log("data:" + data);
              if (data.proCode == '200') {
                plateData = data.proData;
                this.getPlateClassifyIdWithPlateData(plateData);
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getClassifyData() {
        return _getClassifyData.apply(this, arguments);
      }
      return getClassifyData;
    }(),
    //获取板块ID和分类ID
    getPlateClassifyIdWithPlateData: function getPlateClassifyIdWithPlateData(plateData) {
      if (plateData.length > 0) {
        //获取板块ID
        var plateObj = plateData[0];
        this.plateId = plateObj.plateId;
        //获取分类ID
        this.classifyData = plateObj.plateClassifies;
        if (this.classifyData.length > 0) {
          var classifyObj = this.classifyData[0];
          this.classifyId = classifyObj.classifyId;
          this.form.category = classifyObj.classifyName;
        }
      }
      console.log("classifyId:" + this.classifyId);
    },
    // 表单保存口
    saveFormData: function () {
      var _saveFormData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var jsonParam, _yield$apiSaveMerchan, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              jsonParam = {
                jsonParamete: JSON.stringify({
                  fun: "saveMchInfo",
                  param: {
                    merchantId: "",
                    plateId: this.plateId,
                    classifyId: this.classifyId,
                    title: this.form.title,
                    content: this.form.content,
                    picUrl: "",
                    province: this.province,
                    city: this.city,
                    contactPerson: this.form.contactName,
                    contactPhone: this.form.contactPhone,
                    longitude: "",
                    latitude: "",
                    sourceType: 6
                  },
                  version: 1
                })
              };
              _context2.next = 3;
              return (0, _api.apiSaveMerchantInfo)(jsonParam);
            case 3:
              _yield$apiSaveMerchan = _context2.sent;
              data = _yield$apiSaveMerchan.data;
              if (data.proCode == '200') {
                this.form = {
                  category: this.form.category,
                  cityValue: [],
                  contactName: '',
                  contactPhone: '',
                  title: '',
                  content: ''
                }, this.$message({
                  message: '提交成功',
                  type: 'success',
                  duration: '1000'
                });
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function saveFormData() {
        return _saveFormData.apply(this, arguments);
      }
      return saveFormData;
    }()
  }
};